export default "__VITE_ASSET__DdB8OIDN__"